import { Sparkles } from "lucide-react";

/** Rotating circular text badge (ciaoenergy-style sticker). */
export const SpinBadge = ({ text, className = "" }) => (
  <div className={`pointer-events-none relative ${className}`} aria-hidden="true">
    <svg viewBox="0 0 120 120" className="spin-slow h-full w-full">
      <defs>
        <path id="spin-badge-circle" d="M 60,60 m -45,0 a 45,45 0 1,1 90,0 a 45,45 0 1,1 -90,0" />
      </defs>
      <text style={{ fontSize: "10.5px", letterSpacing: "2.4px", fill: "#2DD4BF", fontFamily: "JetBrains Mono, monospace", fontWeight: 700 }}>
        <textPath href="#spin-badge-circle">{text}</textPath>
      </text>
    </svg>
    <div className="absolute inset-0 flex items-center justify-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-full border border-teal-400/40 bg-[#0B1528]/80 shadow-[0_0_30px_rgba(0,245,212,0.25)] backdrop-blur">
        <Sparkles size={20} className="text-teal-300" />
      </span>
    </div>
  </div>
);
